import styled from 'styled-components';

import { Badge } from './badge';
import { IAccentBadgeProps } from './types';

export const AccentBadge = styled(Badge)<IAccentBadgeProps>`
  color: ${Styles.color.grey.three};
  background-color: ${Styles.color.grey.five};
  margin-block: 4px;
  margin-inline-start: 0;
  margin-inline-end: 4px;
  font-weight: 500;
`;
